<!-- FLOATING FOOTER (Cart/Home) -->
    @if (footerenabled()){
        <footer class = "bg-white/95 backdrop-blur border-t border-gray-200 p-4 shadow-[0_-8px_30px_rgba(0,0,0,0.08)] z-30" >
            <div class = "max-w-4xl mx-auto flex flex-row gap-4 items-center flex-wrap sm:flex-nowrap" >
                <div class = "flex-1 flex flex-col justify-center" >
                    @if (navigateService.pageTitle()==='cart') {
                        <span class = "text-[10px] text-gray-400 uppercase font-bold tracking-widest mb-0.5" > {{'totalelordo'|translate}}</span >
                        <span class = "text-2xl font-bold text-primary leading-none" > {{this.cartService.Gross_Total() | currency:'EUR'}}</span >
                    }
                    @else {
                        <span class = "text-[10px] text-gray-400 uppercase font-bold tracking-widest mb-0.5" > {{'estTotal'|translate}}</span >
                        @if (sessionService.currentUser()?.prezzi_ivati){
                            <span class = "text-2xl font-bold text-primary leading-none" > {{this.cartGrossTotal | currency:'EUR'}}</span >
                            <span class="text-[10px] text-gray-500">{{ 'inclusoiva'|translate }}</span>
                        }
                        @else {
                            <span class = "text-2xl font-bold text-primary leading-none" > {{this.cartTotal | currency:'EUR'}}</span >
                            <span class="text-[10px] text-gray-500">{{ 'esclusoiva'|translate }}</span>
                        }
                    }
               </div>
                @if (navigateService.pageTitle()==='cart') {
                  @if (this.cartService.fees()>0) {
                        <div class="flex-1 flex flex-col justify-center">
                            <span class="text-[10px] text-gray-500">{{ 'fees'|translate }}</span>
                            <span class="font-medium">{{ this.cartService.fees() + this.cartService.vat_fees() | currency:'EUR' }}</span>
                            <span class="text-[10px] text-gray-500">{{ 'inclusoiva'|translate }}</span>
                        </div>
                    }
                    @if (this.cartService.shippingCost() > 0) {
                        <div class="flex-1 flex flex-col justify-center">
                            <span class="text-[10px] text-gray-500">{{ 'shipping'|translate }}</span>
                            <span class="font-medium">{{ this.cartService.shippingCost() + this.cartService.vat_shipping() | currency:'EUR' }}</span>
                            <span class="text-[10px] text-gray-500">{{ 'inclusoiva'|translate }}</span>
                        </div>
                    }
                }
                @if (navigateService.pageTitle()!=='cart'){
                    <button (click) = "navigateToCart()" class = "bg-gray-100 text-gray-900 border border-gray-200 px-6 py-3.5 rounded-xl font-bold text-sm hover:bg-gray-200 transition-colors" >
                        {{'viewCart'|translate}}
                    </button >
                }
                @if (navigateService.pageTitle()==='cart'){
                    <button (click) = "navigateToCheckout()" class = "w-full sm:w-auto bg-primary text-white px-8 py-3.5 rounded-xl font-bold text-sm shadow-lg shadow-primary/20 hover:bg-hover transition-colors" >
                        {{'proceedCheckout'|translate}}
                    </button >
                }
            </div >
        </footer>
    }

<!-- CHECKOUT FOOTER -->
@if (navigateService.pageTitle()==='conferma_ordine' && this.cartService.shipaddressConfirmed()){
    <footer class="bg-white border-t border-gray-200 p-4 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] z-30">
        <div class="flex gap-1 max-w-4xl mx-auto">
            <button (click)="placeOrder()" [disabled]="!ishippinginfoconfirmed()"
                    [class.opacity-25]="!ishippinginfoconfirmed()"
                    class="w-full bg-green-700 hover:bg-green-800 text-white py-4 rounded-xl font-bold text-lg shadow-lg active:scale-[0.98] transition-all flex items-center justify-center gap-2">
                <span>{{'confirmPay'|translate }}</span>
                @if (ishippinginfoconfirmed()){
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                }
            </button>
        </div>
        <div class="flex p-1 max-w-4xl mx-auto">
            <button (click)="AnnullaOrdine()"
                    class="w-2/3 sm:w-1/2 bg-red-700 hover:bg-red-800 text-white py-3 rounded-xl font-bold text-md sm:text-lg shadow-lg active:scale-[0.98] transition-all flex items-center justify-center mx-auto">
                <span>{{'stopcheckout'|translate }}</span>
            </button>
        </div>
    </footer>
}
